import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
} from 'axios'
import { API_URL } from '@/configs/site-settings'
import { loadLocalState } from '@/utils/storage'

export const createAxiosInstance = (isPrivate: boolean): AxiosInstance => {
  const instance = axios.create({ baseURL: API_URL })

  instance.interceptors.request.use((config: AxiosRequestConfig) => {
    const token = loadLocalState('user')?.access
    const language = loadLocalState('lang') ?? 'en'

    config.headers = {
      ...config.headers,
      'Accept-Language': language,
      ...(isPrivate && token ? { Authorization: `Bearer ${token}` } : {}),
    }

    return config as InternalAxiosRequestConfig
  })

  return instance
}
